import { css } from 'styled-components';
import { gridMargin, gridMarginY, cellPadding, cellPaddingY } from './Grid.constants';
import cellStyles from './Cell/Cell.style';
export default css `
  display: flex;
  ${({ direction }) => {
    if (direction === 'grid-y') {
        return css `
        flex-flow: column nowrap;
      `;
    }
    return css `
      flex-flow: row wrap;
    `;
}}

  ${({ margin }) => margin &&
    css `
      ${gridMargin}
    `}

  ${({ marginY }) => marginY &&
    css `
      ${gridMarginY}
    `}

  ${({ padding }) => padding &&
    css `
      ${gridMargin}
      & > .cell {
        ${cellPadding}
      }
    `}

  ${({ paddingY }) => paddingY &&
    css `
      ${gridMarginY}
      & > .cell {
        ${cellPaddingY}
      }
    `}
  ${({ asCell }) => asCell &&
    css `
      ${cellStyles}
    `}
`;
